import Crud from './crud'
import { upload_file } from '@/commons/hpod';
import { refreshResource } from "@/commons/utils";
import Vue from 'vue';
var crud = new Crud('images', 'hình ảnh');

const state = {
    ...crud.state,
    selected: {
        id: 0,
        product_code: '',
        note: ''
    },
    image_results: [],
};
const getters = {
    ...crud.getters,
};
const actions = {
    ...crud.actions,
    search_media_file({ commit }, formData) {
        commit("setLoading", { loading: true });
        upload_file("commons", res => {
            commit("setLoading", { loading: false });
            commit('setImageResult', res.data);
            refreshResource();
        }, Vue.http, formData, this.state.authentication.token, 'search-file');
    },
};
const mutations = {
    ...crud.mutations,
    setImageResult(state, res) {
        state.image_results = res.data || null;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};